// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e801930b","455":"8eb57ac6"}[chunkId] + ".chunk.js";
};